import { FunctionComponent, useEffect } from 'react';
import { useAuth } from '@/contexts';
import { Loader } from '@/components/Spinner/Loader';

export const Logout: FunctionComponent = () => {
  const { logOut } = useAuth();

  useEffect(() => {
    logOut();
  }, []);

  return <Loader fullHeight />;
};
